import { Col, Row } from "react-bootstrap";
import LogoInicio from "../componentes/LogoInicio";
import { obras } from "../obras";
import BarraNavegacion from "../componentes/BarraNavegacion";

const Applicaciones = () => {
  return (
    <Row className="pagina-inicio">
      <LogoInicio />
      <BarraNavegacion />
      <Col className="obras">
        {
          obras
            .filter(obra => obra["aplicacion"])
            .map(obra => obra["aplicacion"]
              .map(obra =>
                <Row className="obra my-2" key={obra.nombre}>
                  <Col className="imagen-obra web">
                    <img src={`./img/aplicacion/${obra.nombre}.jpg`} alt={`${obra.nombre}`} />
                  </Col>
                  <Col
                    className={"info-obra web detalle"}
                  >
                    <Row>{obra.nombre}</Row>
                    <Row>{obra.herramientas}</Row>
                    <Row>{obra.año}</Row>
                    {
                      obra.enlace.map(({nombre, url}) =>
                        <Row className="link-externo" key={`${nombre}-${url}`}>
                          <a href={url} target="_blank" rel="noreferrer">
                            {nombre}
                            <i className="fas fa-external-link-alt"></i>
                          </a>
                        </Row>
                      )
                    }
                  </Col>
                </Row>
              ))
        }
      </Col>
    </Row>
  );
};

export default Applicaciones;
